export class AssessmentScheduleMeetingRequestModel {
    evaluationSk: string;
    evaluatorName: string;
    evaluatorTitle: string;
    evaluatorPhone: string;
    evaluatorEmail: string;
    requiredAttendees: string;
    optionalAttendees: string;
    location: string;
    floorRoom: string;
    teamsMeeting: string;
    meetingDate: string;
    startTime: string;
    endTime: string;
    additionalInfo: string;

    constructor(data: any) {
        this.evaluationSk = data?.evaluationSk;
        this.evaluatorName = data?.evaluatorName;
        this.evaluatorTitle = data?.evaluatorTitle;
        this.evaluatorPhone = data?.evaluatorPhone;
        this.evaluatorEmail = data?.evaluatorEmail;
        this.requiredAttendees = data?.requiredAttendees,
        this.optionalAttendees = data?.optionalAttendees
        this.location = data?.location;
        this.floorRoom = data?.floorRoom;
        this.teamsMeeting = data?.teamsMeeting;
        this.meetingDate = data?.meetingDate
        this.startTime = data?.startTime
        this.endTime = data?.endTime
        this.additionalInfo = data?.additionalInfo
    }

    get id(): string {
        return this.evaluationSk
    }
}